import {
  API_AUTH_TOKEN,
  API_LOGIN,
  API_LOGOUT,
} from "../../utils/api/ApiConstant";
import showToast from "../../utils/toastUtil";
import { userAction } from "./user-slice";
import { uiActions } from "../ui/ui-slice";
import { postAxios, postFetchAxios } from "../../Services/commonService";

export const loginUser = async (dispatch, payload) => {
  try {
    dispatch(uiActions.setLoading(true));
    const data = await postFetchAxios({ url: API_LOGIN, payload });
    if (data) {
      const customPayload = {
        userId: payload.user_outo_no,
      };
      const resData = await postFetchAxios({
        url: API_AUTH_TOKEN,
        payload: customPayload,
      });
      dispatch(userAction.setToken(resData?.accessToken));
      dispatch(userAction.updateUser(resData));
    }
    dispatch(uiActions.setLoading(false));
  } catch (err) {
    dispatch(uiActions.setLoading(false));
  }
};

export const logoutUser = async (dispatch) => {
  try {
    // await postAxios({ url: API_LOGOUT, payload: {} });
    await dispatch(userAction.clearUser());
    await dispatch(uiActions.clearUI());
    // showToast.success("Logout successfully");
  } catch (error) {
    console.log("🚀 ~ logoutUser ~ error:", error);
    // showToast.error(error?.data?.message);
  }
};

let isLogoutInProgress = false; // Prevent multiple logout calls

export const handleAxiosError = async (error, dispatch, token) => {
  // Handle network errors
  // if (error?.message === "Network Error") {
  //   if (!isLogoutInProgress) {
  //     isLogoutInProgress = true; // Set the flag
  //     try {
  //       if (token && token !== "") {
  //         await logoutUser(dispatch); // Call logout function
  //       }
  //     } catch (logoutError) {
  //       console.error("Logout error:", logoutError);
  //       showToast.error("Error logging out. Please try again.");
  //     } finally {
  //       // isLogoutInProgress = false; // Reset the flag
  //     }
  //   }
  // }

  // Handle other types of errors (e.g., 401 Unauthorized)
  if (error?.response?.status === 401) {
    try {
      logoutUser(dispatch);
    } catch (logoutError) {
      console.error("Logout error:", logoutError);
    }
  }

  // Return a rejected promise to allow further error handling
  return Promise.reject(error);
};
